/* eslint-disable */
export const QUANTIDADE_POR_PAGINA = 10;

